module.exports = __webpack_public_path__ + "f88ecc7aa6cc62106397e8f0c1cf3422.pdf";